import { Suspense, lazy } from 'react'
import type { ComponentProps } from 'react'

const CollectedSpent = lazy(() => import('./charts').then((m) => ({ default: m.CollectedSpentChart })))
const DepartmentBars = lazy(() => import('./charts').then((m) => ({ default: m.DepartmentBarsChart })))
const AmountBars = lazy(() => import('./charts').then((m) => ({ default: m.AmountBarsChart })))

function Placeholder({ height }: { height: number }) {
  return <div style={{ height }} className="w-full animate-pulse rounded-control bg-line" aria-hidden />
}

export function CollectedSpentChart(props: ComponentProps<typeof CollectedSpent>) {
  return (
    <Suspense fallback={<Placeholder height={props.height ?? 240} />}>
      <CollectedSpent {...props} />
    </Suspense>
  )
}

export function AmountBarsChart(props: ComponentProps<typeof AmountBars>) {
  return (
    <Suspense fallback={<Placeholder height={Math.max(120, props.data.length * 36 + 24)} />}>
      <AmountBars {...props} />
    </Suspense>
  )
}

export function DepartmentBarsChart(props: ComponentProps<typeof DepartmentBars>) {
  return (
    <Suspense fallback={<Placeholder height={Math.max(120, props.data.length * 68 + 16)} />}>
      <DepartmentBars {...props} />
    </Suspense>
  )
}
